import { fetchWithAuth, getApiBase } from "@adafia/ui";
import type { HealthStatus, Stats } from "../types";

const apiBase = getApiBase();

/**
 * Fetches stats from the backend API.
 *
 * @returns A promise that resolves to Stats.
 */
export const fetchStats = async (): Promise<Stats> => {
	const response = await fetch(`${apiBase}/api/v1/stats`, {
		credentials: "include",
	});

	if (!response.ok) {
		const errorBody = await response.text();
		throw new Error(
			`Failed to fetch stats (Status ${response.status}): ${errorBody}`,
		);
	}

	return response.json();
};

/**
 * Fetches health status from the backend API.
 */
export const fetchHealth = async (): Promise<HealthStatus> => {
	const response = await fetch(`${apiBase}/api/v1/health`, {
		credentials: "include",
	});

	if (!response.ok && response.status !== 503) {
		const errorBody = await response.text();
		throw new Error(
			`Failed to fetch health status (Status ${response.status}): ${errorBody}`,
		);
	}

	return response.json();
};

/**
 * Updates the current focus setting.
 */
export const updateFocus = async (focus: string): Promise<void> => {
	const response = await fetchWithAuth(`${apiBase}/api/v1/stats/focus`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ focus }),
	});

	if (!response.ok) {
		const errorBody = await response.text();
		throw new Error(
			`Failed to update focus (Status ${response.status}): ${errorBody}`,
		);
	}
};
